import { Alert, Typography } from "@mui/material";
import { useGetList } from "react-admin";
import { CreateExamForm } from "../AddAppointmentDialog/CreateExamForm";
import { TheoryExam } from "../../model/autovioCalendarEvents";
import { LoadingIndicator } from "../../misc/LoadingIndicator";
import { Student } from "../../providers/studentsProvider";

const _notBilledWarning =
  "Achtung: Hier dokumentierte Termine werden nicht abgerechnet. Für eine Abrechnung bitte den Termin regulär planen.";

export function DocumentHistoricalTheoryExamForm({ student, onSuccess }: { student: Student; onSuccess: () => void }) {
  const { data: theoryExams = [], isLoading } = useGetList<TheoryExam>("calendarEvents", {
    filter: { studentId: student.id, type: ["TheoryExam"], drivingSchoolId: student.drivingSchoolId },
    pagination: { page: 1, perPage: 1 },
    sort: { field: "start", order: "DESC" },
  });
  const lastTheoryExam = theoryExams[0];
  const bookedTraining =
    student.bookedTrainings?.find((bt) => bt.id === lastTheoryExam?.student.bookedTrainingId) ??
    student.bookedTrainings?.find((bt) => bt.includesTheoryExam && !bt.isCancelled);

  if (isLoading) {
    return <LoadingIndicator />;
  }

  return (
    <>
      <Alert severity="warning" sx={{ mb: 2, alignItems: "center" }}>
        <Typography variant="body2">{_notBilledWarning}</Typography>
      </Alert>
      <CreateExamForm
        isHistoricalLesson
        initialExamType="theoretischePruefung"
        student={student}
        drivingLicenseClass={bookedTraining?.drivingLicenseClass}
        onSuccess={onSuccess}
      />
    </>
  );
}
